import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as authAction from '../Store/_redux/AuthStore/authActions';
import { Eye, EyeOff } from 'lucide-react'; // 👁️ ikonları için
import pavzaLogo from "../assets/pavzaLogoNew.svg";
import { useTranslation } from 'react-i18next';

export default function Auth() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tc, setTc] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // 👁️ toggle durumu

    const authFunc = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = { tc, password };

        dispatch(authAction.userLogin(data)).then((res) => {
            setLoading(false);

            if (res) {
                if (res.user?.forceReset === true) {
                    localStorage.setItem("forceReset", "1");
                    navigate("/reset-password");
                    return;
                }

                if (password === "Pavza2022*") {
                    localStorage.setItem("forceReset", "1");
                    navigate("/reset-password");
                    return;
                }

                navigate("/");
            } else {
                alert(t("auth.wrongCredentials"));
            }
        }).catch(() => setLoading(false));
    };

    return (
        <div className='w-full h-screen flex items-center justify-center fixed top-0 right-0 bottom-0 left-0 z-50'>
            <img src={pavzaLogo} alt="Pavza Logo" className='absolute top-0 left-[100px]' style={{ width: 200, height: 200 }} />
            <div className='w-1/3'>
                <h1 className='font-semibold text-3xl py-5'>{t("auth.title")}</h1>
                <div className='flex flex-col span-y-2'>
                    {/* TC Kimlik */}
                    <label htmlFor="auth-tc" className='font-semibold py-2'>{t("auth.tc")}</label>
                    <input
                        id="auth-tc"
                        name="tc"
                        autoComplete="username"
                        onChange={(e) => setTc(e.target.value)}
                        className='border-[1px] rounded-md px-3 py-2 border-input-b mb-5'
                        placeholder={t("auth.tcPlaceholder")}
                    />

                    {/* Şifre */}
                    <label htmlFor="auth-password" className='font-semibold py-2'>{t("auth.password")}</label>
                    <div className="relative mb-5">
                        <input
                            id="auth-password"
                            name="password"
                            autoComplete="current-password"
                            onChange={(e) => setPassword(e.target.value)}
                            type={showPassword ? "text" : "password"}
                            className='border-[1px] rounded-md px-3 py-2 pr-10 border-input-b w-full'
                            placeholder={t("auth.passwordPlaceholder")}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                    </div>
                </div>

                {/* Giriş Butonu */}
                <div className='flex justify-end my-4'>
                    <button
                        onClick={(e) => authFunc(e)}
                        type='submit'
                        className='bg-select-b px-6 py-3 rounded-md text-white flex items-center justify-center'
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                            t("auth.button")
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
